import { Column }  from 'devextreme-react/data-grid';
import unlocked from "../images/desbloqueado2.svg"
import windshield from "../images/iconLunas.svg"
import bodywork from "../images/iconCarroceria.svg"
import pickUp from "../images/iconRecogida.svg";
import tyres from "../images/iconNeumaticos.png"
import { faLock,faLink, faTools, faIndustry, faExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FactoryMenuTable } from './FactoryMenuTable';
import dayjs from 'dayjs';
import active from "../images/iconActivo.svg";
import inactive from "../images/iconInactivo.svg"
import { convertToLocalTime } from '../commonFunctions/commonFunctions';
import { formatToCNPJ, formatToCurrency, formatToPercentage } from '../commonFunctions/FormatterFunctions';

function getServiceIcon(service){
    const lower = service.toLowerCase()
    switch(lower){
        case "mecánica":
            return  <FontAwesomeIcon style={{ fontSize: 20, margin: 3 }} color="#3B5158" icon={faTools} title={service} />;
        case "neumáticos":
            return <img height={20} src={tyres} title={service} />
        case "carrocería":
            return <img className="icon-blue" width={20} src={bodywork} title={service} />
        case "lunas":
            return <img className="icon-blue" width={20} src={windshield} title={service} />
        case "recogida y entrega":
            return <img className="icon-blue" width={20} src={pickUp} title={service} />
        default:
            return undefined
    }
}

function getSLAIcon(data){
    // const yellow = "#f2cd11";
    const red = "#AB4715"

    // if(data.factoryInteractionAllowed){
    //     return <FontAwesomeIcon title={"Se requiere acción en el caso en fábrica"} icon={faExclamation} color={red}/>
    // }
    // const maxFactoryWaitingHours = window.getConfig("FACTORY_WAITING_HOURS");
    // const exceedsFactoryWaitingTime = exceedsMaximunWaitingTime(data.lastFactoryActivityDate, maxFactoryWaitingHours);

    // if(data.newFactoryActivity && !exceedsFactoryWaitingTime){
    //    return <FontAwesomeIcon title={"Modificaciones en el caso en fábrica"} icon={faExclamation} color={red}/>
    // } 
    // if((data.state.toLowerCase() !== "encerrado" && data.state.toLowerCase() !== "no gestionado") && exceedsFactoryWaitingTime){
    //   return <FontAwesomeIcon title={`El caso lleva más de ${maxFactoryWaitingHours} horas sin cambios en fábrica`} icon={faExclamation} color={yellow}/>
    // }

    const exceedsScheduleWaitingTime = dayjs(new Date()).isAfter(dayjs(data.scheduleDate))
    const caseOpen = data.state.toLowerCase() !== "encerrado" && data.state.toLowerCase() !== "no gestionado"
    if(exceedsScheduleWaitingTime && caseOpen){
        return <FontAwesomeIcon title={`El caso supera la fecha de agenda`} icon={faExclamation} color={red}/>   
    }
    

    return <div></div>
}

function exceedsMaximunWaitingTime(lastInteraction, maxTime){
    if(!lastInteraction){
        return false;
    }
    return dayjs(new Date()).isAfter(dayjs(lastInteraction).add(maxTime, "hours"))
}

function renderCampaignStatusColumn(data)
{
    const src = data.value  === true ? active : inactive;
    const title = data.value === true ? "Activa" : "Inactiva";
    return <div className='active-column-cell'><img width={20} src={src} title={title}/><span>{title}</span></div>
}

export const columnas = {
    "Casos":[
        <Column key={"cases-0"} dataField="caseId" caption="Id" cellRender={(data)=>{
            return(
                <div style={{display: "flex", justifyContent:"space-between"}}>{getSLAIcon(data.data)}<span>{data.value}</span></div>
            )
        }}/>,
        <Column key={"cases-13"} dataField="state" caption="Status" />,
        // <Column key={"cases-1"} width={"6%"}  dataField="plate" caption="Matrícula" />,
        <Column key={"cases-2"} width={"17%"}  dataField="customerName" caption="Cliente" />,
        <Column key={"cases-3"} dataField="entryChannel" caption="Canal de entrada" />,
        <Column key={"cases-4"} dataField="taxonomyLevel_1" caption="Nível 1" />,
        <Column key={"cases-5"} dataField="taxonomyLevel_2" caption="Nível 2" />,
        <Column key={"cases-6"} dataField="taxonomyLevel_3" caption="Nível 3" />,
        <Column key={"cases-7"} dataField="taxonomyLevel_4" caption="Nível 4" />,
        <Column key={"cases-8"} dataType="datetime" format="dd/MM/yyyy HH:mm" defaultSortOrder="desc" sortIndex={1} dataField="creationDate" caption="Data de início" />,
        <Column key={"cases-9"} dataType="date" format="dd/MM/yyyy HH:mm" dataField="closeDate" caption="Data final" />,
        // <Column key={"cases-10"} dataType="datetime" format="dd/MM/yyyy HH:mm" dataField="scheduleDate" caption="Data agendada" />,
        <Column key={"cases-11"} dataType="datetime" format="dd/MM/yyyy HH:mm" dataField="slaCloseDate" caption="SLA"/>,
        <Column key={"cases-12"} dataField="user" caption="Agente" />,
        
        
        // <Column key={"cases-14"} dataField="cataloguing" caption="Catalogación veh." />,
        // <Column key={"cases-15"} width={60} dataField={"premium"} caption="Premium" dataType={"string"}  alignment="center"  calculateDisplayValue={(data)=>data.premium === true? "Sí" :  data.premium === false ? "No" : "" }/>,
        <Column key={"cases-16"} dataField="blockedByUser" cellRender={(data) => {
            return (
                <div style={{ textAlign: 'center' }}>{data.value ? <FontAwesomeIcon style={{ fontSize: 20 }} color="#AB4715" icon={faLock} title={`Caso bloqueado por ${data.value ? data.value : "Usuário"}`} /> : <img width={20} src={unlocked} />}</div>
            )
        }
        } caption="Bloqueado" />,
    ],
    "Talleres":
       [
        <Column key={"workshops-0"} visible={false} dataField="id" caption="Id" />,
        <Column key={"workshops-1"} width={60} dataField="externalId" caption="Id" />,
        <Column key={"workshops-2"} width={250} defaultSortOrder="asc" sortIndex={1} dataField="name" caption="Nombre" />,
        <Column key={"workshops-3"} width={200} dataField="address" caption="Dirección" />,
        <Column key={"workshops-4"} dataField="city" caption="Ciudad" />,
        <Column key={"workshops-5"} dataField="province" caption="Provincia" />,
        <Column key={"workshops-6"} width={50} dataField="postalCode" caption="CP" />,
        <Column key={"workshops-7"} width={90} dataField="phone" caption="Teléfono" />,
        <Column key={"workshops-8"} minWidth={100} dataField="brands" caption="Marcas" />,
        <Column key={"workshops-9"} dataField="brandCategory" caption="Categoría marca" />,
        <Column key={"workshops-10"} dataField="networkCategory" caption="Categoría red" />,
        <Column key={"workshops-11"} dataField="note" caption="Notas" />,
        <Column key={"workshops-12"} alignment="center" dataField="services" caption="Servicios" 
            cellRender={(data)=> {
                return <div style={{ textAlign: 'center', alignItems:"center" }}>
                   {data.value.map(e=> getServiceIcon(e))}    
                    </div>
            }}
            />
        ],
        "Historico":[  <Column key={"historic-0"} dataField="caseId" caption="Id" />,
        <Column key={"historic-2"} dataField="entryChannel" caption="Canal de entrada" />,
        <Column key={"historic-3"} dataField="taxonomyLevel_1" caption="Nível 1" />,
        <Column key={"historic-4"} dataField="taxonomyLevel_2" caption="Nível 2" />,
        <Column key={"historic-5"} dataField="taxonomyLevel_3" caption="Nível 3" />,
        <Column key={"historic-6"} dataField="taxonomyLevel_4" caption="Nível 4" />,
        <Column key={"historic-7"} dataType="date" defaultSortOrder="desc" sortIndex={1} format="dd/MM/yyyy HH:mm" dataField="creationDate" caption="Data de início" />,
        <Column key={"historic-8"} dataType="date" format="dd/MM/yyyy HH:mm" dataField="closeDate" caption="Data final" />,
        <Column key={"historic-9"} dataField="user" caption="Agente" />,
        <Column key={"historic-10"} dataField="state" caption="Estado" />],
    "Veículos":[
        <Column key={"vehicles-0"} visible={false} dataField="id" caption="Id" />,
        <Column key={"vehicles-1"} width={120} defaultSortOrder="asc" sortIndex={1} dataField="plate" caption="Matricula" />,
        <Column key={"vehicles-2"} width={150} dataField="brand" caption="Marca" />,
        <Column key={"vehicles-3"} width={"32%"} dataField="model" caption="Modelo" />,
        <Column key={"vehicles-4"} width={90} dataField="kilometrage" caption="Km" />,
        <Column key={"vehicles-5"} dataType="date" width={110}  format="dd/MM/yyyy" dataField="measurementDate" caption="Fecha de lectura" />,
        <Column key={"vehicles-6"} width={150} dataField="customerName" caption="Nombre del cliente" />
    ],
    "Clientes":[
        <Column key={"customers-0"} visible={false} dataField="id" caption="Id" />,
        // <Column key={"customers-1"} width={"10%"} dataField="customerCode" caption="Código de cliente" />,
        <Column key={"customers-1"} width={"10%"} calculateDisplayValue={(e)=> formatToCNPJ(e.cnpj)}  dataField="cnpj" caption="CNPJ" />,
        <Column key={"customers-2"} width={"25%"} defaultSortOrder="asc" sortIndex={1} dataField="customerName" caption="Razão social" />,
        <Column key={"customers-3"} dataField="phone" caption="Telefone" />,
        <Column key={"customers-4"} dataField="email" caption="E-mail" />,
        <Column key={"customers-5"} dataField="isValid" caption="Cliente verificado?" />,
        // <Column key={"customers-5"} dataField="fax" caption="Fax" />,
        // <Column key={"customers-6"} dataField="gdprInformed" caption="Gdpr informado" />,
    ],
    "Itvs":[
        <Column key={"itv-0"} visible={false} dataField="id" caption="Id" />,
        <Column key={"itv-1"} width={"12%"} defaultSortOrder="asc" sortIndex={1} dataField="region" caption="Comunidad autonoma" />,
        <Column key={"itv-2"} width={"12%"} dataField="province" caption="Provincia" />,
        <Column key={"itv-3"} dataField="city" caption="Ciudad" />,
        <Column key={"itv-4"} width={"25%"} dataField="address" caption="Dirección" />,
        <Column key={"itv-5"} dataField="postalCode" caption="Código postal" />,
        <Column key={"itv-6"} dataField="phone" caption="Teléfono" />,
        <Column key={"itv-7"} dataField="net" caption="Red" />,
        <Column key={"itv-8"} dataField="appointmentPhone" caption="Teléfono cita" />,
        <Column key={"itv-9"} alignment="center" width={60} dataField="url" caption="Url"  cellRender={(data) => {
            return (
                <div style={{ textAlign: 'center' }}>{data.value ? <a href={data.value.trim()} target="_blank"> <FontAwesomeIcon style={{ fontSize: 18 }} color="#3B5158" icon={faLink} title={`${data.value}`} /></a> : ""}</div>
            )
        }
        } />,
        <Column key={"itv-10"} width={80} dataField="concerted" caption="Concertado" />
    ],
    "CasosFabrica":[
        <Column key={"factory-0"} width={"10%"} dataField="expedient" calculateCellValue={(data)=>data.currentExpedient || data.expedient} caption="No. Caso" />,
        <Column sortIndex={1}  defaultSortOrder="desc" key={"factory-1"} width={"12%"} dataType="datetime" format="dd/MM/yyyy HH:mm" dataField="entryDate" caption="Fecha entrada" />,
        <Column allowSorting={false} key={"factory-2"} width={"12%"} dataType="datetime" format="dd/MM/yyyy HH:mm" dataField="closeDate" caption="Fecha cierre" />,
        <Column key={"factory-3"}  dataField="area" caption="Área" />,
        <Column allowSorting={false} key={"factory-4"}  dataField="process" caption="Proceso" />,
        <Column allowSorting={false} key={"factory-5"} width={"10%"} caption="Estado" dataField={"state"}/>,
        <Column allowSorting={false} key={"factory-6"} width={50} name={"addComment"} cellRender={(data)=>{
            return (
                <>
                <FactoryMenuTable data={data} id={data.data.processId}/>
                </>    
            )
        }}></Column>
    ],
    "Campañas": [
        <Column key={"campaign-1"} width={"5%"} dataField={"caseId"} caption="Id. Caso" />,
        <Column key={"campaign-2"} width={"5%"} dataField={"plate"} caption="Matrícula"/>,
        <Column key={"campaign-3"} dataField={"customer"} caption="Cliente"/>,
        <Column key={"campaign-4"} dataField={"campaignName"} caption="Nome Campanha"/>,
        <Column key={"campaign-5"} width={"10%"} dataField={"activeCampaign"} cellRender={renderCampaignStatusColumn} caption="Status da Campanha"/>,
        <Column key={"campaign-6"} width={"10%"} dataField={"startDate"} calculateDisplayValue={(e)=>dayjs(convertToLocalTime(e.startDate)).format("DD/MM/YYYY HH:mm")} caption="Data de início" dataType={"datetime"}/>,
        <Column key={"campaign-7"} width={"10%"} dataField={"endDate"} calculateDisplayValue={(e)=> e.endDate && dayjs(convertToLocalTime(e.endDate)).format("DD/MM/YYYY HH:mm")} caption="Data final" dataType={"datetime"}/>,
    ],
    "Montadoras":[
        <Column key={"customers-0"} visible={false} dataField="brandId" caption="Id" />,
        <Column key={"customers-1"} width={"25%"} defaultSortOrder="brandName" sortIndex={1} dataField="brandName" caption="Nome" />,
        <Column key={"customers-2"} width={"10%"} dataField="email" caption="E-mail" />
    ],
    "Modelos":[
        <Column key={"customers-0"} visible={false} dataField="modelId" caption="Id" />,
        <Column key={"customers-1"} width={"5%"} dataType="datetime" format="dd/MM/yyyy" dataField="att" caption="Data de atualização" />,
        <Column key={"customers-2"} width={"5%"} defaultSortOrder="brandName" dataField="brandName" caption="Montadora" />,
        <Column key={"customers-3"} width={"20%"} sortIndex={1} dataField="modelName" caption="Nome" />,
        <Column key={"customers-4"} width={"5%"} dataField="year" caption="Ano" />,
        <Column key={"customers-5"} width={"5%"} dataField="publicPrice" calculateDisplayValue={(e)=> formatToCurrency(e.publicPrice)} caption="Preço Público" />,
        <Column key={"customers-6"} width={"5%"} dataField="discount" calculateDisplayValue={(e)=> formatToPercentage(e.discount)} caption="Desconto" />,
        <Column key={"customers-7"} width={"5%"} dataField="finalPrice" calculateDisplayValue={(e)=> formatToCurrency(e.finalPrice)} caption="Valor Final" />,
        <Column key={"customers-8"} width={"5%"} dataField="billing" caption="Faturamento" />,
        <Column key={"customers-9"} width={"5%"} dataField="category" caption="Categoria" />,
        <Column key={"customers-10"} width={"5%"} dataField="engine" caption="Motor" />,
        <Column key={"customers-11"} width={"5%"} dataField="gearbox" caption="Câmbio" />,
        <Column key={"customers-12"} width={"5%"} dataField="baseColors" caption="Cor base" />,
        <Column key={"customers-14"} width={"5%"} dataField="solidColors" caption="Cor sólida opções" />,
        <Column key={"customers-13"} width={"5%"} dataField="solidColorsPrice" calculateDisplayValue={(e)=> formatToCurrency(e.solidColorsPrice)} caption="Cores sólidas" />,
        <Column key={"customers-15"} width={"5%"} dataField="metalicColors" caption="Cores metálicas" />,
        <Column key={"customers-16"} width={"5%"} dataField="metalicColorsPrice" calculateDisplayValue={(e)=> formatToCurrency(e.metalicColorsPrice)} caption="Cores metálicas opções" />,
        <Column key={"customers-17"} width={"5%"} dataField="customColors" caption="Cores customizadas" />,
        <Column key={"customers-18"} width={"5%"} dataField="customColorsPrice" calculateDisplayValue={(e)=> formatToCurrency(e.customColorsPrice)} caption="Cores customizadas opções" />,
        <Column key={"customers-19"} width={"5%"} dataField="observations" caption="Observações" />,
    ],
};

